import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { BtNumericTextboxModel } from '../bt-numeric-textbox.model';

@Component({
    selector: 'bt-numeric-textbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BtNumericTextboxFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BtNumericTextboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './bt-numeric-textbox-form.component.html',
    styleUrls: ['./bt-numeric-textbox-form.component.scss']
})
export class BtNumericTextboxFormComponent implements ControlValueAccessor {
    @Input() model: BtNumericTextboxModel;
    @Input() value: any;

    propagateChange = (_: any) => {};
    registerOnChange(fn: any) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: number) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onInputChanged(event: any) {
    const value = event.target.value;
    const numericValue: number = !!value ? parseFloat(value.toString().replace(/\s/g, "").replace(",", ".")) : 0;
    this.value = numericValue;
    this.propagateChange(numericValue);
  }
}